export default __webpack_public_path__ + "static/media/Form-GST-REG-06.937f1bd5.png";